"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var Crypto_service_1 = require("../Crypto.service");
var Cache_service_1 = require("../storage/Cache.service");
var utils_1 = require("../../../monolith/services/eventCollector/core/utils");
var HttpServiceRequest_1 = require("./HttpServiceRequest");
var HttpServiceResponse_1 = require("./HttpServiceResponse");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var HttpInterceptorHandler_1 = require("./HttpInterceptorHandler");
var HttpServiceEnhancedPromise_1 = require("./HttpServiceEnhancedPromise");
var Deprecation_service_1 = require("../../../monolith/services/Deprecation.service");
var typedi_1 = require("typedi");
var Url_service_1 = require("../Url.service");
var cloneHttpOptions_1 = require("../../../util/cloneHttpOptions");
var NewRelicPageAction_service_1 = require("../NewRelicPageAction.service");
// eslint-disable-next-line @typescript-eslint/no-empty-function
var defaultGlobalErrorHandler = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/];
}); }); };
var HttpService = /** @class */ (function () {
    function HttpService(cryptoService, cacheService, deprecationService, urlService, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    newRelicPageActionService // TEMPORARY SERVICE TO BE REMOVED AFTER RETRY LOGIC CONFIDENCE IS CONFIRMED
    ) {
        this.cryptoService = cryptoService;
        this.cacheService = cacheService;
        this.deprecationService = deprecationService;
        this.urlService = urlService;
        this.newRelicPageActionService = newRelicPageActionService;
        this.interceptors = [];
        // TODO: Remove concept of globalErrorHandler and move it to HttpInterceptor
        this.globalErrorHandler = defaultGlobalErrorHandler;
        this.pendingPromiseMap = new Map();
    }
    HttpService.prototype.setGlobalErrorHandler = function (handler) {
        if (defaultGlobalErrorHandler !== this.globalErrorHandler) {
            console.error("You've already set the globalErrorHandler, please check!");
        }
        this.globalErrorHandler = handler;
    };
    HttpService.prototype.addInterceptor = function (interceptor) {
        this.interceptors.push(interceptor);
    };
    HttpService.prototype.removeInterceptor = function (interceptor) {
        var index = this.interceptors.indexOf(interceptor);
        this.interceptors.splice(index, 1);
    };
    /**
     * Helper method for DELETE request
     * @param url
     * @param options
     */
    HttpService.prototype.delete = function (url, options) {
        return this.request(__assign(__assign({}, options), { method: 'DELETE', url: url }));
    };
    /**
     * Helper method for GET request
     * @param url
     * @param options
     */
    HttpService.prototype.get = function (url, options) {
        return this.request(__assign(__assign({}, options), { method: 'GET', url: url }));
    };
    /**
     * Helper method for POST request
     * @param url
     * @param body
     * @param options
     */
    HttpService.prototype.post = function (url, body, options) {
        return this.request(__assign(__assign({}, options), { method: 'POST', url: url, body: body || (options === null || options === void 0 ? void 0 : options.body) || {} }));
    };
    /**
     * Helper method for PUT request
     * @param url
     * @param body
     * @param options
     */
    HttpService.prototype.put = function (url, body, options) {
        return this.request(__assign(__assign({}, options), { method: 'PUT', url: url, body: body || (options === null || options === void 0 ? void 0 : options.body) }));
    };
    /**
     * Helper method for PATCH request
     * @param url
     * @param body
     * @param options
     */
    HttpService.prototype.patch = function (url, body, options) {
        return this.request(__assign(__assign({}, options), { method: 'PATCH', url: url, body: body || (options === null || options === void 0 ? void 0 : options.body) }));
    };
    /**
     * Makes a request to the specified url. Will automatically add global headers unless
     * options.ignoreGlobalHeaders = true
     * @param options
     *
     * DO NOT try to rewrite this with the async-await syntax sugar!
     *
     * If you do, you'll find that the constructor of HttpServiceEnhancedPromise is going to be
     * called twice, and the returned `promise` isn't what you want!
     *
     * Please check the code of file `demo.duplicated.initialization.custom.promise.ts`. Or just run
     * `npx ts-node-dev demo.duplicated.initialization.custom.promise.ts` for more ideas.
     *
     * All the wrapper methods, such as `get`, `post`, etc., should not use `async` to avoid this
     * same issue.
     *
     *  - Stone Sun
     */
    HttpService.prototype.request = function (options) {
        var _this = this;
        var _a;
        options.__currentAttemptNumber = options.__currentAttemptNumber || 1;
        options = cloneHttpOptions_1.cloneHttpOptions(options);
        options.responseContentType = options.responseContentType || 'json';
        // Add query strings to url
        if (options.query) {
            for (var key in Object.keys(options.query)) {
                if (!utils_1.hasOwnProperty(options.query, key)) {
                    continue;
                }
                options.url += ((_a = options.url) === null || _a === void 0 ? void 0 : _a.indexOf('?')) === -1 ? '?' : '&';
                options.url += key + "=" + encodeURIComponent(options.query[key]);
            }
        }
        // Check for caching through hashing the url/query params/body
        var cacheKey = null;
        if (options.cache && this.cryptoService.browserSupportsCrypto) {
            cacheKey = this.getCacheKey(options);
            // Check for cache in Cache service to see if we're already made this request recently
            var cacheItem_1 = this.cacheService.get(cacheKey);
            if (cacheItem_1) {
                var t = new HttpServiceEnhancedPromise_1.HttpServiceEnhancedPromise(function (resolve) {
                    // Return cached item
                    resolve(cacheItem_1.value);
                }, 
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                function () { });
                return t;
            }
        }
        // Normalize headers before interceptors
        if (options.headers) {
            HttpServiceRequest_1.HttpServiceRequest.normalizeHeaders(options.headers);
        }
        var request = new HttpServiceRequest_1.HttpServiceRequest(options);
        var handler = request.send();
        // Check if we have a match for a pending API call with matching hash and return that promise
        // instead of making a new one
        var observable;
        var interceptors = __spreadArray(__spreadArray(__spreadArray([], __read(this.interceptors)), __read((options.interceptors || []))), [
            {
                intercept: function (request, next) {
                    // Make sure options passed into request method takes priority
                    return next.handle(request.clone(options));
                },
            },
        ]);
        var chain = interceptors.reduceRight(function (next, interceptor) { return new HttpInterceptorHandler_1.HttpInterceptorHandler(next, interceptor); }, handler);
        var timeToDelay = options.__currentAttemptNumber > 1
            ? Math.abs(Math.pow(2, options.__currentAttemptNumber) - 2 * 1000)
            : 0;
        var events = rxjs_1.of(request).pipe(operators_1.delay(timeToDelay), operators_1.concatMap(function (req) { return chain.handle(req); }), operators_1.shareReplay());
        // Normalize headers again after interceptors in case more were added
        if (options.headers) {
            HttpServiceRequest_1.HttpServiceRequest.normalizeHeaders(options.headers);
        }
        if (cacheKey) {
            if (this.pendingPromiseMap.has(cacheKey)) {
                // Return already running promise
                observable = this.pendingPromiseMap.get(cacheKey);
            }
            else {
                observable = events.pipe(operators_1.filter(function (event) { return event instanceof HttpServiceResponse_1.HttpServiceResponse; }), operators_1.shareReplay());
                this.pendingPromiseMap.set(cacheKey, observable);
            }
        }
        else {
            observable = events.pipe(operators_1.filter(function (event) { return event instanceof HttpServiceResponse_1.HttpServiceResponse; }), operators_1.shareReplay());
        }
        var httpRequestPromise = observable.pipe(operators_1.take(1)).toPromise();
        var enhancedPromise = new HttpServiceEnhancedPromise_1.HttpServiceEnhancedPromise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var httpResponse_1, _a, request_1, type, resolveValue_1, error_1, wasSuccess, willAttemptRetryOnFailure, newRelicLogRetryAction, innerGlobalErrorHandler, _b, _c, _d, _e, ex_1;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 17, , 18]);
                        return [4 /*yield*/, httpRequestPromise];
                    case 1:
                        httpResponse_1 = _f.sent();
                        _f.label = 2;
                    case 2:
                        _f.trys.push([2, 4, , 5]);
                        if (typeof options.body === 'object' &&
                            options.headers &&
                            options.headers['content-type'] === 'application/x-www-form-urlencoded') {
                            options.body = this.urlService.objectToQueryParams(options.body);
                        }
                        return [4 /*yield*/, observable.pipe(operators_1.take(1)).toPromise()];
                    case 3:
                        httpResponse_1 = _f.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _f.sent();
                        request_1 = _a.request, type = _a.type;
                        httpResponse_1 = request_1;
                        console.error('http request failed with ', request_1);
                        return [3 /*break*/, 5];
                    case 5:
                        resolveValue_1 = httpResponse_1.response;
                        if (options.responseFailCallback) {
                            error_1 = options.responseFailCallback(resolveValue_1);
                        }
                        else if (options.isLibraryService) {
                            // TODO: Turn this into an interceptor that is only available in monolith as this will not be needed anywhere else
                            if (httpResponse_1.statusCode >= 400) {
                                error_1 = {
                                    Message: 'Your internet connection appears to be having an issue, please try again.',
                                    resolveValue: resolveValue_1,
                                };
                            }
                            if (resolveValue_1.Error) {
                                error_1 = resolveValue_1.Error;
                            }
                        }
                        wasSuccess = httpResponse_1.ok && !error_1;
                        willAttemptRetryOnFailure = utils_1.hasOwnProperty(options, 'retryCount') &&
                            options.retryCount > 0 &&
                            options.__currentAttemptNumber <= (options.retryCount || 0);
                        newRelicLogRetryAction = function (response) {
                            return _this.newRelicPageActionService.addPageAction('502retry', {
                                initiator: 'SeismicCommon',
                                requestUrl: options.url,
                                statusCode: (response === null || response === void 0 ? void 0 : response.statusCode) || -1,
                            });
                        };
                        if (!wasSuccess && willAttemptRetryOnFailure && options.retryFilterFunction) {
                            if (options.retryFilterFunction(httpResponse_1) === false) {
                                willAttemptRetryOnFailure = false;
                            }
                        }
                        if (wasSuccess && cacheKey) {
                            // Set response value and have it expire in x minutes (default to 60)
                            this.cacheService.set(cacheKey, resolveValue_1, options.cache, options.cacheExpirationMinutes || 60);
                            this.pendingPromiseMap.delete(cacheKey);
                        }
                        if (!wasSuccess) return [3 /*break*/, 6];
                        // TODO: Turn this into an interceptor that is only available in monolith as this will not be needed anywhere else
                        if (options.isLibraryService && options.responseContentType === 'json') {
                            return [2 /*return*/, resolve(resolveValue_1.ServiceResult)];
                        }
                        else {
                            return [2 /*return*/, resolve(resolveValue_1)];
                        }
                        return [3 /*break*/, 16];
                    case 6:
                        if (!this.globalErrorHandler) return [3 /*break*/, 15];
                        innerGlobalErrorHandler = function () {
                            return _this.globalErrorHandler &&
                                _this.globalErrorHandler({
                                    request: request,
                                    response: httpResponse_1,
                                    resolveValue: resolveValue_1,
                                    error: error_1 || resolveValue_1,
                                    retryCallback: options.retryCallback,
                                    preventGlobalErrorDialog: options.preventGlobalErrorDialog,
                                    isLibraryService: options.isLibraryService,
                                });
                        };
                        if (!options.dirtySolutionErrorHandler) return [3 /*break*/, 10];
                        // TEMPORARY SERVICE TO BE REMOVED AFTER RETRY LOGIC CONFIDENCE IS CONFIRMED
                        if (willAttemptRetryOnFailure)
                            newRelicLogRetryAction(httpResponse_1);
                        _b = resolve;
                        if (!willAttemptRetryOnFailure) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.request(__assign(__assign({}, options), { __currentAttemptNumber: options.__currentAttemptNumber + 1 }))];
                    case 7:
                        _c = _f.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        _c = options.dirtySolutionErrorHandler(httpResponse_1.statusCode || 0, resolveValue_1, innerGlobalErrorHandler);
                        _f.label = 9;
                    case 9: return [2 /*return*/, _b.apply(void 0, [_c])];
                    case 10:
                        // TEMPORARY SERVICE TO BE REMOVED AFTER RETRY LOGIC CONFIDENCE IS CONFIRMED
                        if (willAttemptRetryOnFailure)
                            newRelicLogRetryAction(httpResponse_1);
                        _d = resolve;
                        if (!willAttemptRetryOnFailure) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.request(__assign(__assign({}, options), { __currentAttemptNumber: options.__currentAttemptNumber + 1 }))];
                    case 11:
                        _e = _f.sent();
                        return [3 /*break*/, 13];
                    case 12:
                        _e = innerGlobalErrorHandler();
                        _f.label = 13;
                    case 13: return [2 /*return*/, _d.apply(void 0, [_e])];
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        // TEMPORARY SERVICE TO BE REMOVED AFTER RETRY LOGIC CONFIDENCE IS CONFIRMED
                        if (willAttemptRetryOnFailure)
                            newRelicLogRetryAction(httpResponse_1);
                        return [2 /*return*/, willAttemptRetryOnFailure
                                ? this.request(__assign(__assign({}, options), { __currentAttemptNumber: options.__currentAttemptNumber + 1 }))
                                : Promise.reject(error_1 || resolveValue_1)];
                    case 16: return [3 /*break*/, 18];
                    case 17:
                        ex_1 = _f.sent();
                        return [2 /*return*/, reject(ex_1)];
                    case 18: return [2 /*return*/];
                }
            });
        }); }, function () {
            handler.cancel();
        }, httpRequestPromise);
        return enhancedPromise;
    };
    HttpService.prototype.getCacheKey = function (options) {
        if (!this.cryptoService.browserSupportsCrypto) {
            throw new Error('getCacheKey cannot generate a key in this browser.');
        }
        var queryParamsToIgnoreInHash = ['timestamp', 'signature'];
        var url = options.url;
        var urlSplit = url === null || url === void 0 ? void 0 : url.split('?');
        // Because some APIs use things like a signature with a timestamp, creating a hash will always be different
        // even if we want to actually cache the result. This is a workaround!
        if ((urlSplit === null || urlSplit === void 0 ? void 0 : urlSplit.length) === 2) {
            var queryParamsObj_1 = JSON.parse('{"' + decodeURI(urlSplit[1].replace(/&/g, '","').replace(/=/g, '":"')) + '"}');
            queryParamsToIgnoreInHash.forEach(function (key) { return delete queryParamsObj_1[key]; });
            url = urlSplit[0] + "?";
            for (var key in queryParamsObj_1) {
                if (utils_1.hasOwnProperty(queryParamsObj_1, key)) {
                    url += key + "=" + queryParamsObj_1[key];
                }
            }
        }
        var optionsCopy = __assign(__assign({}, options), { url: url });
        var optionsAsStr = JSON.stringify(optionsCopy);
        return this.cryptoService.base64HmacSHA1(optionsAsStr);
    };
    /**
     * Will be removed on October 1st, 2021
     * Please use GlobalHeadersService.getGlobalHeaders instead
     * @deprecated
     * @param profileVersionId
     */
    HttpService.prototype.getGlobalHeaders = function (profileVersionId) {
        var instance = typedi_1.Container.get('instance');
        var globalHeadersService = instance.getService('GlobalHeadersService');
        this.deprecationService.warn('HttpService.getGlobalHeaders will be removed October 1st, 2021', 'GlobalHeadersService', 'getGlobalHeaders');
        return globalHeadersService.getGlobalHeaders(profileVersionId);
    };
    HttpService = __decorate([
        CommonService_decorator_1.CommonService('HttpService'),
        __metadata("design:paramtypes", [Crypto_service_1.CryptoService,
            Cache_service_1.CacheService,
            Deprecation_service_1.DeprecationService,
            Url_service_1.UrlService,
            NewRelicPageAction_service_1.NewRelicPageActionService // TEMPORARY SERVICE TO BE REMOVED AFTER RETRY LOGIC CONFIDENCE IS CONFIRMED
        ])
    ], HttpService);
    return HttpService;
}());
exports.HttpService = HttpService;
//# sourceMappingURL=Http.service.js.map